document.addEventListener('DOMContentLoaded', function () {
    // Select the input element with the name attribute "id"
    const inputElement = document.querySelector('input[name="id"]');

    if (inputElement) {
        // Create a MutationObserver to watch for changes to the input element
        const observer = new MutationObserver(function (mutationsList) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    const inputValue = inputElement.value;
                    // Find all elements with a data-image-variant-id attribute
                    const targetElements = document.querySelectorAll('[data-image-variant-id]');

                    targetElements.forEach((targetElement) => {
                        const ids = targetElement.getAttribute('data-image-variant-id').split(',');
                        if (ids.includes(inputValue)) {
                            targetElement.click();
                        }
                    });
                }
            }
        });

        // Configure the observer to watch for attribute changes
        observer.observe(inputElement, { attributes: true });
    }
});

function handleStickyATCVisibility() {
    // Get the elements
    const stickyAtc = document.querySelector('.zrx-sticky-atc-content-wrapper');
    const footer = document.querySelector('footer'); // Adjust the footer selector if it's different

    if (!stickyAtc || !footer) {
        console.error('Required elements not found!');
        return;
    }

    // Get positions
    const stickyAtcRect = stickyAtc.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();

    // Check if bottom of sticky ATC is at or below the top of the footer
    if (stickyAtcRect.bottom >= footerRect.top) {
        stickyAtc.style.opacity = '0'; // Hide sticky ATC
    } else {
        stickyAtc.style.opacity = '1'; // Show sticky ATC
    }
}

// Attach the function to scroll event
window.addEventListener('scroll', handleStickyATCVisibility);

// Run once to set the initial state
handleStickyATCVisibility();

document.addEventListener('DOMContentLoaded', function () {
    // Select all sections with the class 'shop-compare-mobile-view'
    const sections = document.querySelectorAll('.shop-compare-mobile-view');

    sections.forEach((section) => {
        // Get the list items from both containers within the current section
        const list1 = section.querySelectorAll('.take-from-1 ul li');
        const list2 = section.querySelectorAll('.take-from-2 ul li');

        // Get the container where the items will be appended within the current section
        const generatedContent = section.querySelector('.shop-compare-generated-content');

        // Determine the maximum length to iterate over
        const maxLength = Math.max(list1.length, list2.length);

        // Loop through the list items and append them alternately
        for (let i = 0; i < maxLength; i++) {
            if (i < list1.length) {
                generatedContent.appendChild(list1[i].cloneNode(true));
            }
            if (i < list2.length) {
                generatedContent.appendChild(list2[i].cloneNode(true));
            }
        }
    });
});

function updateButtonName() {
    // Select the button with the name attribute "tcustomizer-add"
    const button = document.querySelector('button[name="tcustomizer-add"]');

    // If the button exists, change its name attribute to "add"
    if (button) {
        button.setAttribute('name', 'add');
    }
}

// Run the updateButtonName function every 200 milliseconds
setInterval(updateButtonName, 200);

// document.addEventListener('DOMContentLoaded', function () {
//     if (window.innerWidth < 768) {
//         const description = document.querySelector('.product__description');
//         const description_p = document.querySelector('.product__description p');
//         const showMoreButton = document.querySelector('.show-more-description');

//         if (description && showMoreButton) {
//             // Calculate the height of three lines
//             const lineHeight = parseFloat(getComputedStyle(description_p).lineHeight);
//             const threeLineHeight = lineHeight * 3;

//             // Set the initial height to three lines
//             description.style.height = `${threeLineHeight}px`;
//             description.style.overflow = 'hidden';

//             // Toggle full height on button click
//             showMoreButton.addEventListener('click', function () {
//                 if (description.style.height === `${threeLineHeight}px`) {
//                     description.style.height = `${description.scrollHeight}px`;
//                     showMoreButton.textContent = 'Show less';
//                 } else {
//                     description.style.height = `${threeLineHeight}px`;
//                     showMoreButton.textContent = 'Show more';
//                 }
//             });
//         }
//     } else {
//         try {
//             const showMoreButton = document.querySelector('.show-more-description');
//             showMoreButton.textContent = '';
//         } catch (error) {
//             console.log('skip');
//         }
//     }
// });

document.addEventListener('DOMContentLoaded', function () {
    /**
     * Initialize “No Chiller” / “Yes Chiller” toggle logic.
     * We’ll call this whenever the snippet is loaded/reloaded.
     */
    function initChillerLogic() {
        console.log('CALLED');
        // Find the "No Chiller" radio
        const noChillerInput = document.querySelector('input.divider-no-option');
        // Find the container of "Yes Chiller" options
        const yesChillerDiv = document.getElementById('option-yes');
        // Grab *all* the radio inputs inside the #option-yes div
        const yesChillerInputs = yesChillerDiv.querySelectorAll("input[type='radio']");
        const yesChillerButton = document.getElementById('option-yes-button');
        const noChillerButton = document.getElementById('option-no-button');

        // A helper function to hide/show the #option-yes div
        // and check the first "Yes Chiller" if none is checked yet.
        function handleNoChillerSelection() {
            noChillerButton.classList.add('checked');
            freshNoChillerButton.classList.add('checked');
            noChillerInput.setAttribute('checked', '');
            noChillerInput.dispatchEvent(new Event('change', { bubbles: true }));
            yesChillerDiv.style.display = 'none';
            yesChillerInputs.forEach((radio) => {
                radio.checked = false;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }
        function handleYesChillerSelection() {
            console.log('fired');
            yesChillerDiv.style.display = 'block';
            if (![...yesChillerInputs].some((radio) => radio.checked)) {
                yesChillerInputs[0].setAttribute('checked', '');
                yesChillerInputs[0].dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        if (!yesChillerButton) return; // If it doesn't exist, bail out
        if (!noChillerButton) return; // If it doesn't exist, bail out

        // Clone the node to strip any old listeners
        yesChillerButton.replaceWith(yesChillerButton.cloneNode(true));
        noChillerButton.replaceWith(noChillerButton.cloneNode(true));

        // Now re-query the DOM for the newly cloned node
        const freshYesChillerButton = document.getElementById('option-yes-button');
        const freshNoChillerButton = document.getElementById('option-no-button');

        // Listen for changes to "No Chiller" radio
        if (noChillerInput) {
            if (noChillerInput.hasAttribute('checked')) {
                yesChillerDiv.style.display = 'none';
            }
        }
        freshNoChillerButton.addEventListener('click', handleNoChillerSelection);
        freshYesChillerButton.addEventListener('click', function () {
            console.log('Yes button fired again!');
            handleYesChillerSelection();
        });
    }

    // 1) Run on initial page load
    initChillerLogic();

    subscribe(PUB_SUB_EVENTS.variantChange, function ({ data }) {
        initChillerLogic(); // Re-initialize all querySelectors & event listeners
    });
});

document.addEventListener('DOMContentLoaded', function () {
    function initPopup() {
        // Get the elements
        let openPopup = document.getElementById('product-open-popup');
        let closePopup = document.getElementById('product-close-popup');
        let popupModal = document.getElementById('product-popup');

        // When the div is clicked, show the popup
        openPopup.addEventListener('click', function () {
            popupModal.style.display = 'flex';
            document.body.classList.add('modal-open'); // disable scroll
        });

        // When the close button is clicked, hide the popup
        closePopup.addEventListener('click', function () {
            popupModal.style.display = 'none';
            document.body.classList.remove('modal-open'); // enable scroll
        });

        // Optional: Close the popup when clicking outside of the modal content
        window.addEventListener('click', function (event) {
            if (event.target === popupModal) {
                popupModal.style.display = 'none';
                document.body.classList.remove('modal-open'); // enable scroll
            }
        });
    }

    initPopup();

    subscribe(PUB_SUB_EVENTS.variantChange, function ({ data }) {
        initPopup(); // Re-initialize all querySelectors & event listeners
    });
});

// document.addEventListener('DOMContentLoaded', function () {
//     const toggleBtn = document.getElementById('toggle-description');
//     const content = document.querySelector('.description-content');
//     const description_p = document.querySelector('.product__description p');
//     const icon = toggleBtn.querySelector('.rm-icon');
//     const label = toggleBtn.querySelector('.rm-label');

//     const lineHeight = parseFloat(getComputedStyle(description_p).lineHeight);
//     const threeLineHeight = lineHeight * 6;

//     content.style.maxHeight = `${threeLineHeight}px`;

//     toggleBtn.addEventListener('click', function () {
//       content.classList.toggle('expanded');
//       const expanded = content.classList.contains('expanded');
//       icon.textContent = expanded ? '−' : '+';
//       label.textContent = expanded ? 'Read less' : 'Read more';
//       content.style.maxHeight = expanded ? '2000px' : `${threeLineHeight}px`;
//     });
// });
